    <div class="g-container">
        <p-confirmDialog />
        <div class="overlay" *ngIf="loadingProject">
            <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
        </div>

        <!-- Placa do projeto: foto, autor, veiculo, descricao e tags num cartao so.
             Os dados do veiculo vinham numa secao propria logo abaixo, gastando a
             largura inteira com 3 valores enquanto esta coluna ficava vazia. -->
        <div class="pj-plate">
            <div class="pj-plate__headline">
                <h1 class="pj-plate__name">{{project?.name || ('project.card.project' | transloco )}}</h1>

                <div class="pj-plate__actions" *ngIf="!project?.isSharing">
                    <button type="button" class="pj-default-btn"
                            [class.is-default]="project?.favorite"
                            (click)="setAsDefaultProject()"
                            [pTooltip]="'project.card.default.header' | transloco"
                            tooltipPosition="top">
                        <i class="pi" [ngClass]="project?.favorite ? 'pi-star-fill' : 'pi-star'"></i>
                    </button>
                    <button type="button" class="action-btn primary" (click)="editProject()">
                        <i class="pi pi-pencil"></i>
                        {{'project.card.editBtn' | transloco}}
                    </button>
                    <button type="button" class="action-btn pj-danger-btn" (click)="disableProject()">
                        <i class="pi pi-trash"></i>
                        {{'project.buttons.deleteProject' | transloco}}
                    </button>
                </div>
            </div>

            <div class="pj-plate__body">
                <div class="pj-gallery">
                    <div class="pj-gallery__main" (click)="openImage(selectedImage ?? '')">
                        <i class="pi pi-search-plus pj-gallery__zoom"></i>
                        <p-skeleton styleClass="skel" height="360px" width="100%" *ngIf="loadingProject" />
                        <img [src]="selectedImage ?? project?.images?.[0]?.href" *ngIf="!loadingProject">
                    </div>
                    <div class="pj-gallery__nav">
                        <button type="button" class="pj-gallery__arrow" (click)="prevThumbs()" [disabled]="thumbStart === 0">
                            <i class="pi pi-chevron-left"></i>
                        </button>
                        <div class="pj-gallery__thumbs">
                            <img *ngFor="let img of visibleThumbs"
                                [src]="img.thumbHref ?? img.href"
                                [class.selected]="img.href === selectedImage"
                                (click)="selectImage(img.href ?? '')"
                                (error)="img.thumbHref = img.href" />
                            <p-skeleton styleClass="skel" height="70px" width="70px" *ngIf="loadingProject" />
                            <p-skeleton styleClass="skel" height="70px" width="70px" *ngIf="loadingProject" />
                            <p-skeleton styleClass="skel" height="70px" width="70px" *ngIf="loadingProject" />
                        </div>
                        <button type="button" class="pj-gallery__arrow" (click)="nextThumbs()"
                            [disabled]="thumbStart + visibleCount >= (project?.images?.length || 0)">
                            <i class="pi pi-chevron-right"></i>
                        </button>
                    </div>
                </div>

                <div class="pj-info">
                    <!-- Autor: a foto do perfil, com iniciais quando nao houver.
                         Nunca a foto do projeto disfarcada de avatar. -->
                    <div class="pj-author">
                        <img *ngIf="!loadingProject && authorAvatarUrl"
                             [src]="authorAvatarUrl"
                             class="pj-author__avatar pj-author__avatar--img" alt="" />
                        <span *ngIf="!loadingProject && !authorAvatarUrl"
                              class="pj-author__avatar">{{ authorInitials }}</span>
                        <p-skeleton styleClass="skel circle" height="44px" width="44px" *ngIf="loadingProject" />
                        <div class="pj-author__text">
                            <span class="pj-author__eyebrow">{{'project.card.by' | transloco}}</span>
                            <span class="pj-author__name">{{ userName || '&#8212;' }}</span>
                        </div>
                    </div>

                    <!-- Veiculo: o que a pagina descreve, ao lado da foto. -->
                    <div class="pj-specs">
                        <div class="pj-spec">
                            <span class="pj-spec__label">{{ 'project.detail.tabVehicle.manufacturer' | transloco }}</span>
                            <span class="pj-spec__value"
                                  [class.pj-spec__value--empty]="!project?.vehicle?.manufacturer">{{project?.vehicle?.manufacturer || '&#8212;'}}</span>
                        </div>
                        <div class="pj-spec">
                            <span class="pj-spec__label">{{ 'project.detail.tabVehicle.model' | transloco }}</span>
                            <span class="pj-spec__value"
                                  [class.pj-spec__value--empty]="!project?.vehicle?.model">{{project?.vehicle?.model || '&#8212;'}}</span>
                        </div>
                        <div class="pj-spec">
                            <span class="pj-spec__label">{{ 'project.detail.tabVehicle.year' | transloco }}</span>
                            <span class="pj-spec__value"
                                  [class.pj-spec__value--empty]="!project?.vehicle?.yearDate">{{(project?.vehicle?.yearDate | date : 'yyyy') || '&#8212;'}}</span>
                        </div>
                    </div>

                    <!-- Descricao vazia mostrava o proprio rotulo ("Descricao do
                         Projeto") no lugar do valor, parecendo texto preenchido. -->
                    <div class="pj-field">
                        <span class="pj-field__label">{{ "tasks.tableShare.description" | transloco }}</span>
                        <p class="pj-field__text"
                           [class.pj-field__text--empty]="!project?.detail">{{ project?.detail || '&#8212;' }}</p>
                    </div>

                    <div class="pj-field">
                        <span class="pj-field__label">Tags</span>
                        <div class="pj-tags">
                            <span class="tag" *ngFor="let tag of project?.tags">{{ tag }}</span>
                            <span class="pj-field__text pj-field__text--empty"
                                  *ngIf="!project?.tags?.length">&#8212;</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Compartilhamento de projetos desativado. O card em PDF saiu junto: o QR dele
             aponta para o feed publico do projeto, que nao existe mais.
        <div class="pj-share">
            <div class="pj-share__link" *ngIf="project?.sharingProjectType?.id === 1 || project?.sharingProjectType?.id === 2">
                <i class="pi pi-globe pj-share__icon"></i>
                <a [routerLink]="[feedPath]" class="pj-share__url">{{ feedPath }}</a>
                <button type="button" class="pj-share__copy" (click)="copyShareLink()" pTooltip="Copiar link">
                    <i class="pi pi-copy"></i>
                </button>
            </div>
            <div class="pj-share__actions">
                <p-button icon="pi pi-share-alt" [label]="'project.detail.shareLink' | transloco"
                    severity="secondary" (onClick)="showDialogShareLink = true"
                    styleClass="share-action-btn" />
                <p-button icon="pi pi-print" [label]="'project.detail.printCard' | transloco"
                    severity="secondary" (onClick)="downloadProjectCardAsPDF()"
                    [loading]="downloadingPDF"
                    styleClass="share-action-btn" />
            </div>
        </div>
        -->

        <!-- VCU -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-microchip section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.vcu' | transloco }}</h2>
                </div>
            </div>
            <div class="vcu-grid" *ngIf="vcus.length">
                <div class="vcu-grid-item" *ngFor="let vcu of vcus; let i = index">
                    <app-card-vcu [vcu]="vcu" [showUnlink]="true" [sharing]="project?.isSharing"
                        (unlink)="dialogUnlink(i)"></app-card-vcu>
                </div>
            </div>
            <div class="pj-empty" *ngIf="!vcus.length && !loadingProject">
                <i class="pi pi-microchip pj-empty__icon"></i>
                <p class="pj-empty__title">{{ 'project.detail.noVcus' | transloco }}</p>
            </div>
        </div>

        <!-- Maps -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-map section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.map' | transloco }}</h2>
                </div>
                <div class="section-toolbar">
                    <div class="search-box">
                        <i class="pi pi-search search-box-icon"></i>
                        <input type="text" (input)="applyFilterGlobalMap($event, 'contains')"
                            placeholder="{{ 'project.detail.tableMap.search' | transloco }}" />
                    </div>
                </div>
            </div>

            <p-table #dtMap [value]="maps" dataKey="id" editMode="row" [rows]="5"
                [loading]="loadingMap" [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'project.detail.tableMap.currentPage' | transloco }}"
                [globalFilterFields]="['name', 'date']">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name" style="width:45%">
                            {{ 'project.detail.tableMap.name' | transloco }} <p-sortIcon field="name" />
                        </th>
                        <th pSortableColumn="date" style="width:30%">
                            {{ 'project.detail.tableMap.date' | transloco }} <p-sortIcon field="date" />
                        </th>
                        <th style="width:25%">{{ 'project.detail.tableMap.action' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-map let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="map">
                        <td>{{ map.name }}</td>
                        <td>{{ map.date }}</td>
                        <td>
                            <p-button [rounded]="true" [text]="true" icon="pi pi-download" (click)="onRowDownload('map', ri)" [disabled]="project?.isSharing" />
                            <p-button [rounded]="true" [text]="true" icon="pi pi-trash" (click)="onRowRemoveMap($event, ri)" [disabled]="project?.isSharing" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3">{{ 'project.detail.tableMap.noFound' | transloco }}.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Logs -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-file section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.log' | transloco }}</h2>
                </div>
                <div class="section-toolbar">
                    <div class="search-box">
                        <i class="pi pi-search search-box-icon"></i>
                        <input type="text" (input)="applyFilterGlobalLog($event, 'contains')"
                            placeholder="{{ 'project.detail.tableLog.search' | transloco }}" />
                    </div>
                </div>
            </div>

            <p-table #dtLog [value]="logs" dataKey="id" editMode="row" [rows]="5"
                [loading]="loadingLog" [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'project.detail.tableLog.currentPage' | transloco }}"
                [globalFilterFields]="['name', 'date']">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name" style="width:45%">
                            {{ 'project.detail.tableLog.name' | transloco }} <p-sortIcon field="name" />
                        </th>
                        <th pSortableColumn="date" style="width:30%">
                            {{ 'project.detail.tableLog.date' | transloco }} <p-sortIcon field="date" />
                        </th>
                        <th style="width:25%">{{ 'project.detail.tableLog.action' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-log let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="log">
                        <td>{{ log.name }}</td>
                        <td>{{ log.date }}</td>
                        <td>
                            <p-button [rounded]="true" [text]="true" icon="pi pi-download" (click)="onRowDownload('log', ri)" [disabled]="project?.isSharing" />
                            <p-button [rounded]="true" [text]="true" icon="pi pi-trash" (click)="onRowRemoveLog($event, ri)" [disabled]="project?.isSharing" />
                            <p-button *ngIf="editing" [rounded]="true" [text]="true" icon="pi pi-times"
                                (click)="onRowEditCancelLog(ri)" pCancelEditableRow />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3">{{ 'project.detail.tableLog.noFound' | transloco }}.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>

    <p-dialog header="{{ 'vcu.detail.unlinkVcu.header' | transloco }}" [modal]="true" [(visible)]="showDialogUnlink"
        [style]="{ width: '25rem' }">
        <div class="dialog-btns">
            <p-button id="dialog-cancel" label="{{ 'vcu.detail.unlinkVcu.cancel' | transloco }}" severity="secondary"
                (onClick)="showDialogUnlink = false" />
            <p-button id="dialog-save" label="{{ 'vcu.detail.unlinkVcu.save' | transloco }}"
                [loading]="unlinkVcuBtnLoading" (onClick)="unlinkVCU()" />
        </div>
    </p-dialog>

    <!-- Compartilhamento de projetos desativado.
    <app-share-project-modal
        [projectId]="projectID"
        [ownerUserId]="userOwnerID"
        [sharingTypeId]="sharingTypeIdForShare"
        [isOwner]="true"
        [(visible)]="showDialogShareLink"
        (sharingTypeChanged)="onSharingTypeChanged($event)">
    </app-share-project-modal>
    -->

    <p-toast key="toastProject" />
    <app-register-vcu [showDialog]="showVcuDialog" (closeDialog)="updateVcuDialog()" [vcu]="null"
        [editMode]="false"></app-register-vcu>
    <app-register-project [showDialog]="showEditProjectDialog" (closeDialog)="closeProjectDialog()" (saved)="onProjectSaved()" [project]="project"
        [editMode]="true"></app-register-project>

    <!-- Image Lightbox -->
    <div class="lightbox-overlay" *ngIf="displayImage" (click)="closeLightbox($event)"
         (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
        <button class="lightbox-close" (click)="closeImage()">
            <i class="pi pi-times"></i>
        </button>

        <button class="lightbox-nav lightbox-prev" (click)="lightboxPrev($event)"
                *ngIf="(project?.images?.length ?? 0) > 1">
            <i class="pi pi-chevron-left"></i>
        </button>

        <div class="lightbox-content">
            <img [src]="imageSelectedUrl" class="lightbox-image" (click)="$event.stopPropagation()" />
            <div class="lightbox-counter" *ngIf="(project?.images?.length ?? 0) > 1">
                {{ lightboxIndex + 1 }} / {{ project?.images?.length }}
            </div>
        </div>

        <button class="lightbox-nav lightbox-next" (click)="lightboxNext($event)"
                *ngIf="(project?.images?.length ?? 0) > 1">
            <i class="pi pi-chevron-right"></i>
        </button>

        <div class="lightbox-thumbs" *ngIf="(project?.images?.length ?? 0) > 1"
             (click)="$event.stopPropagation()">
            <img *ngFor="let img of project?.images ?? []; let i = index"
                 [src]="img.href" [class.active]="i === lightboxIndex"
                 (click)="lightboxGoTo(i)" />
        </div>
    </div>

    <!-- Card para impressao (oculto, capturado pelo html2canvas). Faixas em SVG
         inline porque o html2canvas nao renderiza clip-path. -->
    <div id="print-card-content" class="print-card" style="position: fixed; left: -9999px; top: 0;">
        <svg class="print-card__band" viewBox="0 0 400 36" preserveAspectRatio="none" aria-hidden="true">
            <polygon fill="#E31F12" points="0,0 400,0 400,24 280,24 268,36 132,36 120,24 0,24" />
        </svg>
        <div class="print-card__body">
            <h2 class="print-card__title">{{ 'project.detail.printCardTitle' | transloco }}</h2>
            <p class="print-card__instruction" [innerHTML]="'project.detail.printCardInstruction' | transloco"></p>
            <img *ngIf="qrCodeDataUrl" [src]="qrCodeDataUrl" class="print-card__qr" alt="QR Code" />
        </div>
        <svg class="print-card__band" viewBox="0 0 400 36" preserveAspectRatio="none" aria-hidden="true">
            <polygon fill="#E31F12" points="0,12 120,12 132,0 268,0 280,12 400,12 400,36 0,36" />
        </svg>
    </div>
